<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="9.959" height="17.09" viewBox="0 0 9.959 17.09">
    <path id="Path_19779" data-name="Path 19779" d="M1141.148,500.172l-7.838,7.838,7.838,7.838"
      transform="translate(-1131.896 -499.465)" fill="none" stroke="#0963ff" stroke-width="2" />
  </svg>
</template>